import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    description: 'Ship from locations header',
    defaultMessage: 'Ship From Locations',
    id: 'KM3XAO',
  },
  pickupSettingsHeader: {
    description: 'Pickup Settings Page Header',
    defaultMessage: 'Pickup - {warehouseName}',
    id: 'wc8/v9',
  },
  shipFromDescription: {
    description: 'ship from location descriptions',
    defaultMessage:
      'Your ship from locations provide origin information and shipment return information for packages shipped through ShipStation. Your <b>default Ship From Location</b> will be applied to all incoming orders unless otherwise applied by an automation rule.',
    id: '2UUYZ9',
  },
  addNewShipFrom: {
    description: 'add new ship from button',
    defaultMessage: 'Add New Location',
    id: 'yeYp1p',
  },
  shipFromName: {
    description: 'Ship From Name',
    defaultMessage: 'Name',
    id: 'di4zlF',
  },
  shipFromReturnToAddress: {
    description: 'Ship From return to address',
    defaultMessage: 'Return to Address',
    id: 'r/ejvi',
  },
  shipFromShipFromAddress: {
    description: 'Column Header for Ship From Address',
    defaultMessage: 'Ship from Address',
    id: 'FUaXvF',
  },
  shipFromInventorySource: {
    description: 'Column Header for Inventory Source',
    defaultMessage: 'Inventory Source',
    id: 'k4gLTO',
  },
  shipFromDefault: {
    description: 'Ship From default',
    defaultMessage: 'Default',
    id: 'U+zHQf',
  },
  shipFromActions: {
    description: 'Ship From actions',
    defaultMessage: 'Actions',
    id: 'hLgPDf',
  },
  inventorySource: {
    description: 'inventory source for ship from location modal',
    defaultMessage: 'Inventory Source',
    id: 'BMsA4l',
  },
  shipstationInventory: {
    description: 'native intentory source warehouse group name',
    defaultMessage: 'ShipStation Inventory',
    id: 'nXbag6',
  },
  defaultLocation: {
    description: 'Checkbox for default location',
    defaultMessage: 'This is my default location',
    id: 'k5ZrV+',
  },
  saveChanges: {
    description: 'save changes button for ship from location modal',
    defaultMessage: 'Save Changes',
    id: '/mwhvf',
  },
  editLocation: {
    description: 'Ship From actions Edit location button',
    defaultMessage: 'Edit location',
    id: 'Mx06Os',
  },
  delete: {
    description: 'Ship From actions confirm delete button',
    defaultMessage: 'Delete',
    id: '3EBypW',
  },
  deleteLocation: {
    description: 'Ship From actions delete location button',
    defaultMessage: 'Delete location',
    id: 'ub5W8M',
  },
  editPickupSettings: {
    description: 'Ship From actions edit pickup button',
    defaultMessage: 'Edit pickup settings',
    id: 'ABV/UC',
  },
  pickupSettings: {
    description: 'Ship From edit pickup settings modal header',
    defaultMessage: 'Pickup Settings',
    id: 'vzfQ2T',
  },
  carrierInstructions: {
    description: 'Ship From edit pickup settings carrier instructions textbox label',
    defaultMessage: 'Carrier Instructions <span>(optional)</span>',
    id: 'bGkeJz',
  },
  pickupContact: {
    description: 'Ship From edit pickup settings pickup contact',
    defaultMessage: 'Pickup Contact',
    id: 'KYLD3X',
  },
  defaultPickupWindow: {
    description: 'Ship From edit pickup settings default pickup window - Available Hours Label',
    defaultMessage: 'Available Hours',
    id: 'Sa/5+W',
  },
  localDeliveryScheduleColumnHeader: {
    description: 'Ship From Settings Table Header',
    defaultMessage: 'Schedule',
    id: 'j4k25a',
  },
  defaultPickupWindowIsSameSchedule: {
    description: 'Ship From edit pickup settings default pickup window is same schedule checkbox label',
    defaultMessage: 'Same schedule all days',
    id: '8q58hK',
  },
  defaultPickupWindowSubtext: {
    description: 'Ship From edit pickup settings default pickup window help text',
    defaultMessage:
      'The hours for pickup service should be when the store doors are open and someone is available to handle a pickup. You should end your pickup service one hour before close to accommodate any returns.{br}{br}EX: If you are open from 9 - 5, your pickup service hours would be 9 - 4, allowing an hour at the end of day to handle returns.',
    id: 'aglEz2',
  },
  pickAndPackTimeSectionLabel: {
    description: 'Ship From edit pickup settings Pick and Pack Time Dropdown Label',
    defaultMessage: 'Pick and Pack Time',
    id: 'wDrCze',
  },
  pickAndPackTimeHelperLabel: {
    description: 'Ship From edit pickup settings Pick and Pack Time Helper Label',
    defaultMessage: 'Helps determine if an order will be ready for same-day shipment.',
    id: 'x/KwyN',
  },
  pickPackHourAndMinutesOption: {
    description: 'Ship From edit pickup settings Pick and Pack Time Dropdown Hour and Multiple Minutes Item',
    defaultMessage: '{hours, plural, =0 {} one {# hour} other {# hours}} {minutes} minutes',
    id: 'vnmvIM',
  },
  onDays: {
    description: 'Ship From edit pickup settings on days',
    defaultMessage: 'On Days',
    id: 'WYUkS6',
  },
  preferredPickup: {
    description: 'Ship From edit pickup settings preferred pickup',
    defaultMessage: 'Preferred Pickup Time',
    id: 'idGkBM',
  },
  selectTime: {
    description: 'Select a time default value',
    defaultMessage: 'Select time',
    id: '0KyyRp',
  },
  editShipFromLocation: {
    description: 'Edit Ship From Location button',
    defaultMessage: 'Edit Ship From Location',
    id: 'fj0ici',
  },
  Monday: {
    description: 'Edit Ship From monday pickup option',
    defaultMessage: 'Mon',
    id: '2t7wua',
  },
  Tuesday: {
    description: 'Edit Ship From tuesday pickup option',
    defaultMessage: 'Tue',
    id: '2iqSqK',
  },
  Wednesday: {
    description: 'Edit Ship From wednesday pickup option',
    defaultMessage: 'Wed',
    id: 'LV1gMM',
  },
  Thursday: {
    description: 'Edit Ship From thursday pickup option',
    defaultMessage: 'Thu',
    id: 'XFzxWq',
  },
  Friday: {
    description: 'Edit Ship From friday pickup option',
    defaultMessage: 'Fri',
    id: 'ERh2J7',
  },
  Saturday: {
    description: 'Edit Ship From saturday pickup option',
    defaultMessage: 'Sat',
    id: 'KLTi+w',
  },
  Sunday: {
    description: 'Edit Ship From sunday pickup option',
    defaultMessage: 'Sun',
    id: 'VOeeQ3',
  },
  ifSupportedByCarrier: {
    description: 'Edit Ship From if supported by carrier note',
    defaultMessage: 'If supported by carrier',
    id: '+XURj8',
  },
  TwoHundredFiftyCharactersMax: {
    description: 'Edit Ship From 250 characters max note',
    defaultMessage: '250 characters max',
    id: '+ww2YE',
  },
  deleteHeader: {
    description: 'Ship From delete modal header',
    defaultMessage: 'Delete Ship From Location',
    id: 'boB3k4',
  },
  warningHeader: {
    description: 'Ship From warning modal header',
    defaultMessage: 'Warning',
    id: 'W9agYP',
  },
  failedToSaveShipFrom: {
    description: 'Ship From failed to save message',
    defaultMessage: 'Unable to save Ship From settings, please try again.',
    id: 'UGdjOj',
  },
  cancel: {
    description: 'Ship From cancel button',
    defaultMessage: 'Cancel',
    id: '/kkXe2',
  },
  warningMessage: {
    description: 'Ship From warning modal message',
    defaultMessage:
      'The default Ship From Location cannot be deleted. Assign another Ship From Location as the default before deleting this one.',
    id: 'RErrJi',
  },
  ok: {
    description: 'Ship From warning modal button',
    defaultMessage: 'Ok',
    id: 'wVV+TS',
  },
  returnsWarningMessage: {
    description: 'Ship From returns warning modal message',
    defaultMessage:
      'This location is currently being used to receive customer returns in the Returns & Exchanges settings. To delete it, you must first set a new Return To Location.',
    id: 'DL21Y3',
  },
  returnsWarningHeader: {
    description: 'Ship From returns warning modal header',
    defaultMessage: 'Cannot Delete Ship From Location',
    id: '4GhX0Y',
  },
  updateReturnToLocation: {
    description: 'Ship From returns warning modal button text',
    defaultMessage: 'Update Return To Location',
    id: 'mgTRk5',
  },
  confirmMessage: {
    description: 'Ship From delete modal text',
    defaultMessage: 'Are you sure you want to delete this Ship From Location?',
    id: 'rjxq3+',
  },
  noInventory: {
    description: 'Ship from no Inventory',
    defaultMessage: 'None',
    id: 'Ds6/U7',
  },
  noShipFroms: {
    description: 'No shipfroms currently exist',
    defaultMessage: 'There are currently no records',
    id: 'X9RayN',
  },
  aggregateWarehouseName: {
    description: 'Default name for aggregate inventory warehouse',
    defaultMessage: 'All Stock',
    id: 'DiddA6',
  },
  externalWarehouseDropdownLabel: {
    description: 'Label for inventory source dropdown showing the external provider name next to the external source name',
    defaultMessage: '{externalInventoryProviderName} ({externalInventorySourceName})',
    id: 'kvzRwj',
  },
  editShipFromSuccessMessageTitle: {
    description: 'Edit ship from success notification message title',
    defaultMessage: 'Ship From Location Successfully Updated',
    id: 'bO51Lo',
  },
  addShipFromSuccessMessageTitle: {
    description: 'Add ship from success notification message title',
    defaultMessage: 'Ship From Location Successfully Added',
    id: 'kEn78L',
  },
  deleteShipFromSuccessMessageTitle: {
    description: 'Delete ship from success notification message title',
    defaultMessage: 'Ship From Location Successfully Deleted',
    id: 'B14x+/',
  },
  failedShipFromContactsTitle: {
    description: 'Ship From Contacts Error failedShipFromContactsTitle',
    defaultMessage: 'Failed to get Ship From Contacts',
    id: 'hatNg/',
  },
  failedShipFromContactsContent: {
    description: 'Ship From Contacts Error failedShipFromContactsContent',
    defaultMessage: 'An unexpected error occurred while loading contacts.',
    id: 'LoTFcP',
  },
  carrierInstructionsTooLong: {
    description: 'Ship From Instruction Too Long Error',
    defaultMessage: 'Carrier instructions must be 250 characters or less.',
    id: '6dPi7B',
  },
  learnMoreAboutPickupSettings: {
    description: 'Ship From Learn More About Pickup Settings Link',
    defaultMessage: 'Learn more about Pickup Settings',
    id: 'zceWC3',
  },
  noScheduleSet: {
    description: 'Ship From Row -> Warning Label with Action Link',
    defaultMessage: 'No schedule set. <link>Edit pickup settings</link>',
    id: 'xCIPMi',
  },
  closed: {
    description: 'Ship From Row -> Local Delivery Schedule -> Warehouse closed',
    defaultMessage: 'Closed',
    id: 'FGDEVt',
  },
  seeExtendedSchedule: {
    description: 'Ship From Row -> Local Delivery Schedule -> See Extended Schedule Link',
    defaultMessage: 'See extended schedule',
    id: 'AUFT+r',
  },
});
